var _path, _path2, _rect, _path3, _path4, _rect2, _rect3, _path5, _path6, _path7, _rect4, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconBank = function SvgIconBank(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 28,
    viewBox: "0 0 33 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.067 0.284216L0 8.00318H33L16.933 0.284216C16.6593 0.152714 16.3407 0.152714 16.067 0.284216Z",
    fill: "#2974B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.00391H33V8.58931C33 9.14159 32.5523 9.58931 32 9.58931H0.999999C0.447714 9.58931 0 9.14159 0 8.58931V8.00391Z",
    fill: "#413D45"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 24.4902,
    width: 33,
    height: 3.1708,
    rx: 1.5854,
    fill: "#413D45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.45703 9.58789H8.77618V10.4904C8.77618 11.0427 8.32846 11.4904 7.77618 11.4904H3.45703C2.90475 11.4904 2.45703 11.0427 2.45703 10.4904V9.58789Z",
    fill: "#2974B2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.45703 23.5898C2.45703 23.0376 2.90475 22.5898 3.45703 22.5898H7.77618C8.32847 22.5898 8.77618 23.0376 8.77618 23.5898V24.4923H2.45703V23.5898Z",
    fill: "#2974B2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.16016,
    y: 11.4922,
    width: 4.91489,
    height: 11.0978,
    fill: "#2974B2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.9258,
    y: 11.4922,
    width: 4.91489,
    height: 11.0978,
    fill: "#2974B2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2227 9.58789H30.5418V10.4904C30.5418 11.0427 30.0941 11.4904 29.5418 11.4904H25.2227C24.6704 11.4904 24.2227 11.0427 24.2227 10.4904V9.58789Z",
    fill: "#2974B2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2227 23.5898C24.2227 23.0376 24.6704 22.5898 25.2227 22.5898H29.5418C30.0941 22.5898 30.5418 23.0376 30.5418 23.5898V24.4923H24.2227V23.5898Z",
    fill: "#2974B2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9883 9.58789H20.0096V10.4904C20.0096 11.0427 19.5618 11.4904 19.0096 11.4904H13.9883C13.436 11.4904 12.9883 11.0427 12.9883 10.4904V9.58789Z",
    fill: "#2974B2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.6914,
    y: 11.4922,
    width: 5.61702,
    height: 11.0978,
    fill: "#2974B2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9883 23.5898C12.9883 23.0376 13.436 22.5898 13.9883 22.5898H19.0096C19.5618 22.5898 20.0096 23.0376 20.0096 23.5898V24.4923H12.9883V23.5898Z",
    fill: "#2974B2"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconBank);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/iconBank.b7f177c5eebe57124c8fb15489cd3f0d.svg";